export default "__VITE_ASSET__vLtl6RVf__"